var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    opacity: 0.4,
    d: "M10.0003 18.3327C14.6027 18.3327 18.3337 14.6017 18.3337 9.99935C18.3337 5.39698 14.6027 1.66602 10.0003 1.66602C5.39795 1.66602 1.66699 5.39698 1.66699 9.99935C1.66699 14.6017 5.39795 18.3327 10.0003 18.3327Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-2",
    d: "M12.4999 13.3327C12.0332 13.3327 11.6582 12.9577 11.6582 12.4993C11.6582 12.041 12.0332 11.666 12.4915 11.666C12.9499 11.666 13.3249 12.041 13.3249 12.4993C13.3249 12.9577 12.9582 13.3327 12.4999 13.3327Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M7.50867 8.33268C7.042 8.33268 6.66699 7.95768 6.66699 7.49935C6.66699 7.04102 7.04199 6.66602 7.50033 6.66602C7.95866 6.66602 8.33366 7.04102 8.33366 7.49935C8.33366 7.95768 7.967 8.33268 7.50867 8.33268Z",
    fill: "#E8F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "active-color-1",
    d: "M7.49989 13.1249C7.34156 13.1249 7.1832 13.0666 7.0582 12.9416C6.81654 12.6999 6.81654 12.2999 7.0582 12.0582L12.0582 7.0582C12.2999 6.81654 12.6999 6.81654 12.9416 7.0582C13.1833 7.29987 13.1833 7.69992 12.9416 7.94159L7.94159 12.9416C7.81659 13.0666 7.65823 13.1249 7.49989 13.1249Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCircle);
export default __webpack_public_path__ + "static/media/discount-circle.9896201bcf91d30415e9ebec8ea75aeb.svg";
export { ForwardRef as ReactComponent };